// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__2ENJS","colBig":"styles_colBig__LsNCS","colSmall":"styles_colSmall__2FlFQ"};